<div class="specific-container">
    <div class="bckp-jobs-started overflow-ellipsis" title="{{item.result.started}}">
        {{item.result.started | formatDateHour }}
    </div>
    <div class="bckp-jobs-server overflow-ellipsis" title="{{item.result.serverShort}}">
        {{item.result.serverShort}}
    </div>
    <div class="bckp-jobs-master overflow-ellipsis" title="{{item.result.master}}">
        {{item.result.master}}
    </div>
    <div class="bckp-jobs-policy-name overflow-ellipsis" title="{{item.result.policyName}}">
        {{item.result.policyName}}
    </div>
    <div class="bckp-jobs-policy-type overflow-ellipsis" title="{{item.result.policyType}}">
        {{item.result.policyType}}
    </div>
    <div class="bckp-jobs-status-desc overflow-ellipsis" title="{{item.result.statusDesc}}">
        {{item.result.statusCode}} - {{item.result.statusDesc}}
    </div>
</div>
